import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import ActivableRenderer from '../ActivableRenderer'
import styles from './Modal.css'
import Overlay from '../Overlay'

const propTypes = {
  /** show or hide */
  isActive: PropTypes.bool,
  /** Modal Title */
  title: PropTypes.string,
  /** Modal Type for styling purposes */
  kind: PropTypes.oneOf(['small', 'normal', 'large']),
  /** Custom CSS Classes */
  className: PropTypes.string,
  /** Run function on escape press */
  onEscKeyDown: PropTypes.func,
  /** Run function on overlay click */
  onOverlayClick: PropTypes.func,
  /** Run function on overlay mousedown */
  onOverlayMouseDown: PropTypes.func,
  /** Run function on overlay mousemove */
  onOverlayMouseMove: PropTypes.func,
  /** Run function on overlay mouseup */
  onOverlayMouseUp: PropTypes.func,
  /** Run function on x click */
  onClose: PropTypes.func,
  /** Contents in the modal */
  children: PropTypes.node,
  /** Make model contents scrollable. ANTI PATTERN USE sparingly */
  isScrollable: PropTypes.bool,
}

const defaultProps = {
  isActive: false,
  kind: 'normal'
}

/**
 * The Modal Component should be used sparingly
 */
const Modal = (props) => {
  const classes = classNames(
    'component-modal',
    styles.modal,
    styles[props.kind],
    props.className,
    {
      [styles.active]: props.isActive
    }
  )

  let renderCloseButton

  if (props.onClose) {
    renderCloseButton = <div className={styles.close} onClick={props.onClose} />
  }

  return (
    <Overlay
      isActive={props.isActive}
      isScrollable={props.isScrollable}
      onClick={props.onOverlayClick}
      onEscKeyDown={props.onEscKeyDown}
      onMouseDown={props.onOverlayMouseDown}
      onMouseMove={props.onOverlayMouseMove}
      onMouseUp={props.onOverlayMouseUp}
    >
      <div className={classes}>
        {renderCloseButton}
        <section role='dialog' className={styles.body}>
          {props.title ? <h2 className={styles.title}>{props.title}</h2> : null}
          {props.children}
        </section>
      </div>
    </Overlay>
  )
}

Modal.propTypes = propTypes
Modal.defaultProps = defaultProps
export default ActivableRenderer()(Modal)



// WEBPACK FOOTER //
// ../src/components/Modal/Modal.js